module.exports = __webpack_public_path__ + "static/media/small-clubs.ed7d2048.svg";